

export default function basicNavigation() {

    const $navbarSearchToggle = $('.toggle-search');
    const $navbarSearch = $('.navbar-search');
    const $navbar = $('.navbar');
    const $navbarCollapse = $('.navbar .navbar-collapse');
    const $window = $(window);

    let navbarTogglable = $navbar.hasClass('navbar-togglable');
    let navbarState = 'big';
    let navbarCollapsed = false;

    const setNavbarSmall = () => {
        if (navbarTogglable && navbarState !== 'small') {
            $('body').addClass('navbar-small');
            navbarState = 'small';
        }
    };

    const setNavbarBig = () => {
        if (navbarTogglable && navbarState !== 'big') {
            $('body').removeClass('navbar-small');
            navbarState = 'big';
        }
    };

    const setNavbarState = (action) => {
        let scrollTop = $window.scrollTop();
        if (scrollTop > 100) {
            setNavbarSmall();
        } else {
            setNavbarBig();
        }
    };

    $window.on('scroll', () => setNavbarState('scroll'));

    $window.on('load', () => setNavbarState('scroll'));

    $navbarCollapse.on('show.bs.collapse', () => {
        setNavbarState('collapse');
        navbarCollapsed = true;
    });

    $navbarCollapse.on('hide.bs.collapse', () => {
        setNavbarState('collapse');
        navbarCollapsed = false;
    });

    $navbarSearchToggle.on('click', function(e){
        e.preventDefault();
        $('body').toggleClass("show-search");
        setTimeout(()=>($navbarSearch.find('input[type=search]').focus()), 450);
    });

}